// Angular dependencies
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PageCreepLevelRouterModule } from './page-creep-level.router';
import { CoreModule } from '../core.module';

// Import vendor modules
import { NgxPopperModule } from 'ngx-popper';

// Page creep level component
import { PageCreepLevelComponent } from './page-creep-level.component';

// Componets of this page
import { CreepComponent } from './creep.component';
import { PowerResourceNeededComponent } from './power-resource-needed.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    // Vendors
    NgxPopperModule,
    // Page route
    PageCreepLevelRouterModule
  ],
  declarations: [
    PageCreepLevelComponent,
    // Componets of this page
    CreepComponent,
    PowerResourceNeededComponent
  ]
})
export class PageCreepLevelModule { }



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-creep-level.module/page-creep-level.module.ts